<template>
  <iframe v-bind="$attrs"></iframe>
</template>

<script>
export default {
  name: "M4Iframe"
};
</script>
